module.exports = __webpack_public_path__ + "static/img/button1.b8698d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button1.png
// module id = PgGc
// module chunks = 4